import { FhsAxios } from "../../services/axios";
import {
  isUserNameIncorrect,
  isRecoveryCodeIncorrect
} from "@/helpers/passwordRecovery";

import router from "@/router";

export default {
  state: {
    isRecoveryCodeSent: false,
    recoveryToken: "",
    recoveryErrorMessage: "",
    // Переменная отображает процесс загрузки данных
    isRecoveryLoading: false
  },
  actions: {
    // Действие для получения кода восстановления
    fetchRecoveryCode({ commit, _ }, userName = "") {
      commit("setRecoveryLoading", true);
      FhsAxios.post("/user/request-reset-by-sms", {
        username: userName
      })
        .then(response => {
          if (isUserNameIncorrect(response)) {
            commit("setRecoveryErrorMessage", "incorrect user name");
            return;
          }
          // Если сообщение успешно отправилось или было отправлено, устанавливаем isRecoveryCodeSent в true
          if (
            Number(response.data.status) === 1 ||
            response.data.result.error ===
              "Сообщение уже было отправлено, дождитесь смс или попробуйте позже"
          ) {
            commit("setIsRecoveryCodeSent", true);
          }
        })
        .catch(() => {
          router.push({ path: "/auth/recovery-error" });
        })
        .finally(() => commit("setRecoveryLoading", false));
    },
    checkRecoveryCode({ commit, getters }, payload) {
      commit("setRecoveryLoading", true);
      FhsAxios.post("/user/check-reset-password-code", {
        username: payload.userName,
        code: payload.recoveryCode
      })
        .then(response => {
          // Если код восстановления неправильный, показываем соответствующую ошибку и прерываем выполнение фукнции
          if (isRecoveryCodeIncorrect(response)) {
            commit("setRecoveryErrorMessage", "recovery code is incorrect");
            return;
          }
          try {
            let recoveryToken = response.data.result.token;
            if (recoveryToken) {
              commit("setRecoveryToken", recoveryToken);
            }
          } catch {
            return;
          }
        })
        .catch(() => {
          router.push({ path: "/auth/recovery-error" });
        })
        .finally(() => commit("setRecoveryLoading", false));
    },
    resetPassword({ commit, _, state }, password) {
      commit("setRecoveryLoading", true);
      FhsAxios.post("/user/reset-password", {
        newpass: password,
        token: state.recoveryToken
      })
        .then(response => {
          let status = response.data.status;
          // Если сброс пароля прошел успешно, перенаправляем пользователя на соответствующую страницу
          if (status === 1) {
            router.push({ path: "/auth/recovery-success" });
            return;
          } else {
            // Если произошла ошибка, перенаправляем пользователя на соответствующую страницу
            router.push({ path: "/auth/recovery-error" });
            return;
          }
        })
        .finally(() => commit("setRecoveryLoading", false));
    },
    clearRecoveryErrorMessage({ commit }) {
      commit("unsetRecoveryErrorMessage");
    },
    clearRecoveryData({ commit }) {
      commit("unsetRecoveryData");
    }
  },
  mutations: {
    setIsRecoveryCodeSent(state, flag) {
      state.isRecoveryCodeSent = flag;
    },
    setRecoveryToken(state, recoveryToken) {
      state.recoveryToken = recoveryToken;
    },
    setRecoveryErrorMessage(state, errorMessage) {
      state.recoveryErrorMessage = errorMessage;
    },
    unsetRecoveryErrorMessage(state) {
      state.recoveryErrorMessage = "";
    },
    setRecoveryLoading(state, flag) {
      state.isRecoveryLoading = flag;
    },
    unsetRecoveryData(state) {
      state.isRecoveryCodeSent = false;
      state.recoveryToken = "";
      state.recoveryErrorMessage = "";
      state.isRecoveryLoading = "";
    }
  },
  getters: {
    isRecoveryCodeSent(state) {
      return state.isRecoveryCodeSent;
    },
    isTokenReceived(state) {
      return Boolean(state.recoveryToken);
    },
    recoveryErrorMessage(state) {
      return state.recoveryErrorMessage;
    },
    isRecoveryLoading(state) {
      return state.isRecoveryLoading;
    }
  }
};
